module.exports = __webpack_public_path__ + "img/trash.e4668d50.svg";